import {
  Namespace,
  useTranslation,
  UseTranslationOptions,
  UseTranslationResponse,
} from 'react-i18next'
import { useCallback } from 'react'

export const useTranslationNS = <N extends Namespace>(
  ns: N | Readonly<N>,
  options?: UseTranslationOptions,
): UseTranslationResponse<N, undefined> => {
  const { t, ...rest } = useTranslation(ns, options)

  const tWithNs = useCallback(
    // @ts-ignore
    (key, options) =>
      t(key, {
        ns,
        ...(typeof options === 'object' && options),
      }),
    [ns, t],
  )

  return {
    ...rest,
    t: tWithNs,
  }
}
